module.exports = __webpack_public_path__ + "static/media/react-resources-main.8cc7ad0b.png";